module.exports = __webpack_public_path__ + "static/media/brand-icon.78ce4bc6.png";